const getUserRole = (userAccess) => {
  const { superAdmin, dashboardAccess, manageUsers, manageEquipmentDeactivation } = userAccess;

  if (superAdmin) return 'Super Admin';
  if (dashboardAccess && manageUsers && manageEquipmentDeactivation) return 'Administrator';
  if (dashboardAccess && manageUsers) return 'Manager';
  if (dashboardAccess) return 'Editor';

  return 'Viewer';
};

export const getUserAccessAndRoleFullProfile = (permissions) => {
  let userAccess = {};

  if (permissions?.length) {
    permissions.forEach(({ name, group }) => {
      if (name === 'superAdmin' || group === 'ww2-dashboard') {
        userAccess[name] = true;
      }
    });

    userAccess.manageUsers = userAccess['superAdmin'] || userAccess['manageUsers'];

    userAccess.manageSensorData = userAccess['superAdmin'] || userAccess['viewSensorData'];

    userAccess.manageData =
      userAccess['superAdmin'] ||
      (userAccess['readonlyAccess'] || userAccess['viewOnlyAccess'] ? false : true);

    userAccess.manageEquipmentDeactivation =
      userAccess['superAdmin'] || userAccess['manageEquipmentDeactivation'];

    userAccess.appAccess =
      userAccess['superAdmin'] ||
      userAccess['dashboardAccess'] ||
      userAccess['readonlyAccess'] ||
      userAccess['viewOnlyAccess'];
  }

  return { userAccess, userRole: getUserRole(userAccess) };
};
